import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Range from "./Range";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteAllScales } from "../../Store";
import IconSvg from "../../../../../SharedComponents/IconSvg";
import { AdminButton } from "../../../../SharedComponents/ListView";

export default function RangeList() {
  const dispatch = useDispatch();
  const ranges = useSelector((state) => state.scale.ranges);

  const deleteScales = () => {
    dispatch(deleteAllScales());
  };

  return (
    <Col xs="12" md="7">
      <Row xs="auto">
        {ranges?.map((range, index) => (
          <Range range={range} key={index} />
        ))}
        <Col>
          {ranges?.length > 0 && (
            <AdminButton variant="danger" onClick={deleteScales}>
              <IconSvg icon="trash-can" fill="#fff" />
            </AdminButton>
          )}
        </Col>
      </Row>
    </Col>
  );
}
